define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");

    var template = require("manager-templates/special-occasion/specialOccasionShiftItemView.tmpl");

    var SpecialOccasionShiftTimePickView = require("manager-views/special-occasion/SpecialOccasionShiftTimePickView");

    var SpecialOccasionShiftItemView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionShiftItemView = Marionette.ItemView.extend({
            template: template,
            tagName: "li",
            className:"shift-row-container",
            ui: {
                shiftTimePickContainer: ".shift-time-pick-container",
                deleteButton: ".shift-delete-button",
                addShiftButtonContainer: ".add-shift",
            },
            uiComponents: {
                timePick: {
                    type: SpecialOccasionShiftTimePickView,
                    options: {
                        el: "view.ui.shiftTimePickContainer",
                        channel: "view.channel",
                        model: "view.model"
                    }
                },
                addShiftButton: {
                    type: Button,
                    options: {
                        el: "view.ui.addShiftButtonContainer",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addShift"
                    }
                }
            },
            events: {
                "click @ui.deleteButton": "_onDeleteButtonClicked"
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onValidatedInvalid: function (model, errors) {
                return this._onValidatedInvalid(model, errors);
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.specialOccasionEventModel = options.specialOccasionEventModel;
            },

            _onDeleteButtonClicked: function() {
                this.channel.trigger("SpecialOccasionShiftItemView:shift:delete", this.model);
            },


            _onValidatedInvalid: function(model, errors) {
                this.uiComponents.timePick.setErrors(errors);
            },

            _addShift: function() { //trigger the controller and then he will add to the model
                this.channel.trigger("SpecialOccasionShiftItemView:shifts:add", this.specialOccasionEventModel);
            },
        });
    }


    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionShiftItemView;
});
